export const excelInterfacesServiceMutationKeys = {
  importLotXLSX: 'importLotXLSX',

  exportProposal: 'exportProposal',
  importProposal: 'importProposal',

  importCriteria: 'importCriteria',
} as const;
